import { render, staticRenderFns } from "./ProduitChips.vue?vue&type=template&id=a86aad18"
import script from "./ProduitChips.vue?vue&type=script&lang=js"
export * from "./ProduitChips.vue?vue&type=script&lang=js"
import style0 from "./ProduitChips.vue?vue&type=style&index=0&id=a86aad18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports